<template>
  <div>
    <ModalDelete v-bind="{ pageId }" v-on="{ deleted: removeAccountPageId }" />
  </div>
</template>

<script>
import { middleware } from '@/routes/guards';
import ModalDelete from '@/components/Pages/ModalDelete.vue';
import { accountPageComputed, accountPageMethods } from '@/store/helper';

export default {
  name: 'PageDelete',
  components: {
    ModalDelete,
  },
  props: {
    pageId: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...accountPageComputed,
  },
  beforeRouteEnter: middleware('account-permission:delete pages'),
  methods: {
    ...accountPageMethods,
    removeAccountPageId(pageId) {
      this.setIds([...this.ids.filter((id) => id !== pageId)]);
    },
  },
};
</script>
